import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, apiFunctionNames } from './constants';
import { NahradniSazbaLakovaci } from './nahradniSazbaLakovaci';
import { NahradniHodinovaSazba } from './nahradniHodinovaSazba';
import { SmluvniCenaND } from './smluvniCenaND';
import { DependentTableNames } from './store/types';

class FakturacniProfilProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case NahradniHodinovaSazba.name:
				return `/${this.area}/${NahradniHodinovaSazba.name}/Schema`;
			case NahradniSazbaLakovaci.name:
				return `/${this.area}/${NahradniSazbaLakovaci.name}/Schema`;
			case SmluvniCenaND.name:
				return `/${this.area}/${SmluvniCenaND.name}/Schema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case NahradniHodinovaSazba.name:
				return `/${this.area}/${NahradniHodinovaSazba.name}/`;
			case NahradniSazbaLakovaci.name:
				return `/${this.area}/${NahradniSazbaLakovaci.name}/`;
			case SmluvniCenaND.name:
				return `/${this.area}/${SmluvniCenaND.name}/`;
			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}

	[apiFunctionNames.copyFakturaceProfilAll](filter: { idZ: Number, idDo: Number }) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CopyFakturaceProfilAll`, filter);
	}

	[apiFunctionNames.copyFakturaceProfilHodSzbNahr](filter: { idZ: Number, idDo: Number }) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CopyFakturaceProfilHodSzbNahr`, filter);
	}

	[apiFunctionNames.copyFakturaceProfilNdPcNahr](filter: { idZ: Number, idDo: Number }) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CopyFakturaceProfilNdPcNahr`, filter);
	}

	[apiFunctionNames.copyFakturaceProfilLakSzbNahr](filter: { idZ: Number, idDo: Number }) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CopyFakturaceProfilLakSzbNahr`, filter);
	}
}

export const apiProvider = new FakturacniProfilProvider(DMS_MODULE, NAME);
